import { toast } from "react-toastify";
import API from "../../Api/Api";
import { API_END_POINT } from "../../Api/EndPoints";
import { getRandomNumber, isDefined, uploadFile } from "../../Utils";
import qs from "qs";
import NEW_API from "../../Api/NewApi";
import { closeCenteredModal } from "./centeredModal";
import { deleteRecord } from "../../Utils/api";
import moment from "moment";

export const getProspectStats =
  (filters, signal) => async (dispatch, getState) => {
    const { user } = getState().userReducer;
    dispatch({ type: "PROSPECT_STATS_LOADING" });
    try {
      const config = {
        params: {},
      };
      config.params.status = filters?.status?.code;
      config.params.country = filters?.country?.code;
      config.params.business_affiliate = filters?.business_affiliate?.code;
      config.params.marque = user?.attributes?.marque?.data?.id;

      config.signal = signal;
      const { data } = await API.get(
        `${API_END_POINT}api/prospect-stats`,
        config,
      );
      dispatch({ type: "PROSPECT_STATS_FETCHED", payload: data });
    } catch (error) {
      if (error.name === "CanceledError" || error.code === "ERR_CANCELED")
        return dispatch({ type: "PROSPECT_STATS_CANCELLED" });
      dispatch({ type: "PROSPECT_STATS_FETCHED", payload: error });
    }
  };

export const getCurrentProspect = (id, signal) => async (dispatch) => {
  if (!isDefined(id)) return;
  dispatch({ type: "CURRENT_PROSPECT_LOADING" });
  const config = {
    params: {
      populate: [
        "spaMarques",
        "business_affiliate.user",
        "billingAddresses.city",
        "billingAddresses.country",
        "deliveryAddresses.city",
        "deliveryAddresses.country",
        "interlocutors.photo",
        "activities",
        "note",
        "marque",
        "actions.interlocutor",
        "geoEntity",
      ],
    },
    signal,
  };
  try {
    const { data } = await API.get(
      `${API_END_POINT}api/prospects/${id}`,
      config,
    );
    dispatch({ type: "CURRENT_PROSPECT_SUCCESS", payload: data?.data });
  } catch (error) {
    if (error.name === "CanceledError") return;
    if (error?.response?.status === 404) {
      dispatch({ type: "CURRENT_PROSPECT_ERROR", payload: error });
    }
  }
};

export const createAction = (actions, prospectId) => async () => {
  try {
    for (const action of actions) {
      if (isDefined(action?.id)) {
        await API.put(`${API_END_POINT}api/actions/${action?.id}`, {
          data: {
            ...action,
            type: action?.type?.code,
            interlocutor: action?.interlocutor?.code,
            prospect: prospectId,
          },
        });
      } else {
        await API.post(`${API_END_POINT}api/actions`, {
          data: {
            ...action,
            date: action?.date ?? new Date(),
            type: action?.type?.code,
            interlocutor: action?.interlocutor?.code,
            prospect: prospectId,
          },
        });
      }
    }
  } catch {}
};

export const createUpdateIntrelocutors =
  (interlocutors, prospectId) => async () => {
    try {
      for (const interlocutor of interlocutors) {
        if (isDefined(interlocutor?.id)) {
          const { data } = await API.get(
            `${API_END_POINT}api/interlocutors/${interlocutor?.id}`,
            {
              params: {
                populate: {
                  photo: true,
                },
              },
            },
          );
          const oldPhoto = data?.data?.attributes?.photo?.data;
          let newPhoto = null;

          if (interlocutor?.photo instanceof File) {
            if (oldPhoto) {
              await API.delete(
                `${API_END_POINT}api/upload/files/${oldPhoto?.id}`,
              );
            }
            newPhoto = await uploadFile(interlocutor.photo);
          }

          await API.put(
            `${API_END_POINT}api/interlocutors/${interlocutor?.id}`,
            {
              data: {
                ...interlocutor,
                photo: newPhoto || oldPhoto?.id,
                influenceDecision: interlocutor?.influenceDecision?.code,
                spaKnowledge: interlocutor?.spaKnowledge?.code,
              },
            },
          );
        } else {
          let newPhoto = null;

          if (interlocutor?.photo instanceof File) {
            newPhoto = await uploadFile(interlocutor.photo);
          }

          await API.post(`${API_END_POINT}api/interlocutors`, {
            data: {
              ...interlocutor,
              influenceDecision: interlocutor?.influenceDecision?.code,
              spaKnowledge: interlocutor?.spaKnowledge?.code,
              photo: newPhoto,
              prospect: prospectId,
            },
          });
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

export const createUpdateAction =
  (action, isReminder, status, t) => async (dispatch, getState) => {
    dispatch({ type: "CREATE_UPDATE_ACTION_LOADING" });
    try {
      const { currentProspect } = getState().prospectsReducer;
      const prospectId = currentProspect?.id;
      const query = qs.stringify({
        populate: ["interlocutor"],
      });
      if (isDefined(action?.id)) {
        const { data } = await API.put(
          `${API_END_POINT}api/actions/${action?.id}?${query}`,
          {
            data: {
              ...action,
              type: action?.type?.code,
              interlocutor: action?.interlocutor?.code,
              prospect: prospectId,
            },
          },
        );
        dispatch({ type: "UPDATE_ACTION_SUCCESS", payload: data?.data });
      } else {
        const { data } = await API.post(
          `${API_END_POINT}api/actions?${query}`,
          {
            data: {
              ...action,
              isReminder,
              status,
              date:
                action?.date && moment(action?.date).isValid()
                  ? action?.date
                  : new Date(),
              type: action?.type?.code,
              interlocutor: action?.interlocutor?.code,
              prospect: prospectId,
            },
          },
        );
        dispatch({ type: "CREATE_ACTION_SUCCESS", payload: data?.data });
      }
    } catch (error) {
      console.log(error);
      if (isDefined(action?.id)) {
        toast.error(t("An error occurred while updating the action"));
      } else {
        toast.error(t("An error occurred while creating the action"));
      }
    }
  };

export const convertReminderToAction = (id) => async (dispatch) => {
  try {
    const query = qs.stringify({
      populate: ["interlocutor"],
    });
    const { data } = await API.put(
      `${API_END_POINT}api/actions/${id}?${query}`,
      {
        data: {
          isReminder: false,
        },
      },
    );
    dispatch({ type: "UPDATE_ACTION_SUCCESS", payload: data?.data });
  } catch {}
};

export const createUpdateNote =
  (formData, prospectId) => async (_, getState) => {
    try {
      const { currentProspect } = getState().prospectsReducer;
      const id = currentProspect?.attributes?.note?.data?.id;

      await API[isDefined(id) ? "put" : "post"](
        `${API_END_POINT}api/notes/${id ?? ""}`,
        {
          data: {
            ...formData,
            prospect: prospectId,
          },
        },
      );
    } catch {}
  };

export const createUpdateLocation =
  (formData, prospectId) => async (_, getState) => {
    try {
      const { currentProspect } = getState().prospectsReducer;
      const id = currentProspect?.attributes?.geoEntity?.data?.id;

      await API[isDefined(id) ? "put" : "post"](
        `${API_END_POINT}api/geo-entities/${id ?? ""}`,
        {
          data: {
            ...formData,
            prospect: prospectId,
          },
        },
      );
    } catch {}
  };

export const createUpdateProspect =
  (
    { infos, note, interlocutors, geoEntity },
    id,
    deletedInterlocutors,
    callback = () => {},
    t,
  ) =>
  async (dispatch, getState) => {
    const { user } = getState().userReducer;
    const marque = user?.attributes?.marque?.data?.id;
    try {
      dispatch({ type: "CREATE_UPDATE_PROSPECT_LOADING" });
      const query = qs.stringify({
        populate: [
          "spaMarques",
          "business_affiliate.user",
          "billingAddresses.city",
          "billingAddresses.country",
          "deliveryAddresses.city",
          "deliveryAddresses.country",
          "interlocutors",
          "activities",
          "note",
          "marque",
        ],
      });

      const poolSpaGroup = infos?.poolSpaGroup?.code;
      const traffic = infos?.traffic?.code;
      const storeArea = infos?.storeArea?.code;
      const business_affiliate =
        user?.attributes?.userRole === 2
          ? user?.attributes?.business_affiliate?.data?.id
          : infos?.business_affiliate?.code;
      const digitalAds = infos?.digitalAds?.code;
      const source = infos?.source?.code;
      const status = infos?.status?.code;

      const {
        data: { data: createdProspect },
      } = await API[isDefined(id) ? "put" : "post"](
        `${API_END_POINT}api/prospects/${id ?? ""}?${query}`,
        {
          data: {
            ...infos,
            status,
            poolSpaGroup,
            traffic,
            storeArea,
            business_affiliate,
            marque,
            source,
            digitalAds,
          },
        },
      );

      await dispatch(createUpdateNote(note, createdProspect?.id));
      await dispatch(createUpdateLocation(geoEntity, createdProspect?.id));
      await dispatch(
        createUpdateIntrelocutors(interlocutors, createdProspect?.id),
      );
      // delete Intorlocutors
      for (const interlocutor of deletedInterlocutors) {
        console.log(interlocutor.photo);
        if (interlocutor?.photo?.id) {
          await API.delete(
            `${API_END_POINT}api/upload/files/${interlocutor?.photo?.id}`,
          );
        }
        await deleteRecord(interlocutor.id, "interlocutors");
      }
      const {
        data: { data: prospectData },
      } = await API.get(`${API_END_POINT}api/prospects`, {
        params: {
          filters: {
            id: { $eq: createdProspect?.id },
          },
          populate: {
            business_affiliate: {
              populate: {
                user: true,
              },
            },
            note: true,
            marque: true,
            geoEntity: true,
            interlocutors: true,
            actions: {
              sort: "createdAt:desc",
              populate: {
                interlocutor: {
                  sort: "createdAt:desc",
                },
              },
            },
          },
        },
      });

      await dispatch({
        type: "CREATE_UPDATE_PROSPECT_SUCCESS",
        payload: prospectData[0],
      });
      callback();

      if (isDefined(id)) {
        toast.success(t("The prospect has been updated successfully!"));
      } else {
        toast.success(t("Prospect created successfully!"));
      }
    } catch (error) {
      console.log(error);
      await dispatch({
        type: "CREATE_UPDATE_PROSPECT_ERROR",
      });
      if (isDefined(id)) {
        toast.error(t("An error occurred while updating the prospect"));
      } else {
        toast.error(t("An error occurred while creating the prospect"));
      }
    }
  };

// Addresses
const createCity = async (payload) => {
  const newCity = await NEW_API.post("/api/cities", {
    data: {
      name: payload.city,
      country: payload.country.code,
      zipCode: payload.zip,
      code: payload?.code,
    },
  });
  return newCity.data.data.id;
};
const updateCity = async (cityId, payload) => {
  const newCity = await NEW_API.put(`/api/cities/${cityId}`, {
    data: {
      name: payload.city.name,
      country: payload.country.code,
      zipCode: payload.zip,
      code: payload.code,
    },
  });
  return newCity.data.data.id;
};

export const updateAdress =
  (addressId, payload, prospectId, callBack, t) => async (dispatch) => {
    let cityId = payload.city.code;

    if (!cityId) {
      cityId = await createCity(payload);
    } else {
      await updateCity(cityId, payload);
    }

    try {
      await API.put(`api/addresses/${addressId}`, {
        data: {
          name: payload.name,
          street: payload.street,
          zip: payload.zip,
          country: payload.country.code,
          city: cityId,
          prospect: prospectId,
        },
      });
      // callBack ? callBack() : dispatch(refetchReseller(resellerId));
      if (isDefined(prospectId)) {
        dispatch(getCurrentProspect(prospectId));
      }

      dispatch(closeCenteredModal());

      toast.success(t("Delivery address successfully updated"));
    } catch (error) {
      console.log(error);
    }
  };

export const createNewDeliveryAddress =
  (payload, prospectId, type, callBack, t) => async (dispatch, getState) => {
    //LINK IT ON ADRESSE DE LIVRAISON OU FACTURATION

    const relationType =
      type === "addresseDeLivraison"
        ? { prospect: prospectId || null }
        : { prospectBillings: prospectId || null };

    let cityId = payload.city.code;
    if (!cityId) {
      cityId = await createCity(payload);
    } else {
      await updateCity(cityId, payload);
    }

    try {
      await API.post(`api/addresses`, {
        data: {
          name: payload.name,
          street: payload.street,
          zip: payload.zip,
          country: payload.country.code,
          city: cityId,
          ...relationType,
        },
      });

      if (isDefined(prospectId)) {
        dispatch(getCurrentProspect(prospectId));
      }
      if (callBack) callBack();

      dispatch(closeCenteredModal());

      toast.success(t("Delivery address successfully created"));
    } catch (error) {
      toast.error(t("An error has occurred!"));
      console.log(error);
    }
  };

// COMMENTS
export const getProspectComments = (prospect, signal) => async (dispatch) => {
  try {
    dispatch({ type: "FETCH_COMMENTS_PROSPECT_LOADING" });
    const query = qs.stringify({
      populate: [
        "attachments.file",
        "user.photo",
        "user.marque",
        "emojis.user",
      ],
      sort: ["createdAt:desc"],
      filters: {
        prospect: { id: { $eq: prospect } },
      },
    });
    const {
      data: { data: commentData },
    } = await API.get(`${API_END_POINT}api/comments?${query}`, {
      signal,
    });
    dispatch({ type: "FETCH_COMMENTS_PROSPECT_SUCCESS", payload: commentData });
  } catch (error) {
    if (error.name === "CanceledError") return;
    dispatch({ type: "FETCH_COMMENTS_PROSPECT_ERROR", payload: error });
  }
};

export const createProspectComment =
  (comment, prospect, user, successCallback, t) => async (dispatch) => {
    dispatch({ type: "CREATE_COMMENTS_PROSPECT_LOADING" });

    try {
      const {
        data: { data: commentData },
      } = await API.post(`${API_END_POINT}api/comments?populate=*`, {
        data: {
          text: comment?.text,
          prospect,
          user,
        },
      });

      if (comment?.attachments?.length > 0) {
        for (const file of comment?.attachments) {
          const fileId = await uploadFile(file);
          const { data } = await API.post(
            `${API_END_POINT}api/attachments?populate=*`,
            {
              data: {
                date: new Date(),
                file: fileId,
                comment: commentData?.id,
              },
            },
          );
          commentData.attributes.attachments.data?.push(data?.data);
        }
      }

      dispatch({
        type: "CREATE_COMMENTS_PROSPECT_SUCCESS",
        payload: {
          ...commentData,
          attributes: { ...commentData?.attributes },
        },
      });
      successCallback();
      toast.success(t("A comment has been added"));
    } catch (error) {
      console.log(error);
    }
  };

export const deleteProspectAction = (id, t) => async (dispatch) => {
  try {
    await deleteRecord(id, "actions");

    dispatch({ type: "DELETE_ACTION_SUCCESS", payload: id });
  } catch (error) {
    toast.error(t("An error occurred while deleting the action"));
    dispatch({ type: "DELETE_ACTION_ERROR", payload: error });
  }
};

export const deleteProspect = (id, t) => async (dispatch) => {
  try {
    const { data } = await API.get(`${API_END_POINT}api/prospects/${id}`, {
      params: {
        populate: [
          "actions",
          "geoEntity",
          "note",
          "interlocutors",
          "billingAddresses",
          "deliveryAddresses",
        ],
      },
    });
    if (!data?.data) {
      toast.error(t("An error occurred while deleting the prospect"));
      return;
    }

    const {
      actions,
      geoEntity,
      note,
      interlocutors,
      billingAddresses,
      deliveryAddresses,
    } = data?.data?.attributes;

    await deleteRecord(id, "prospects");

    if (actions?.data?.length > 0) {
      for (const action of actions?.data) {
        await deleteRecord(action?.id, "actions");
      }
    }

    if (geoEntity?.data) {
      await deleteRecord(geoEntity?.data?.id, "geo-entities");
    }

    if (note?.data) {
      await deleteRecord(note?.data?.id, "notes");
    }

    if (interlocutors?.data?.length > 0) {
      for (const interlocutor of interlocutors?.data) {
        await deleteRecord(interlocutor?.id, "interlocutors");
      }
    }

    if (billingAddresses?.data?.length > 0) {
      for (const address of billingAddresses?.data) {
        await deleteRecord(address?.id, "addresses");
      }
    }

    if (deliveryAddresses?.data?.length > 0) {
      for (const address of deliveryAddresses?.data) {
        await deleteRecord(address?.id, "addresses");
      }
    }

    dispatch({ type: "DELETE_PROSPECT_SUCCESS", payload: id });
    toast.success(t("Prospect deleted successfully!"));
  } catch (error) {
    toast.error(t("An error occurred while deleting the prospect"));
    dispatch({ type: "DELETE_PROSPECT_ERROR", payload: error });
  }
};

export const getProspectUsers = (id) => async (dispatch) => {
  dispatch({ type: "PROSPECT_USERS_LOADING" });
  try {
    const { data } = await API.get(`${API_END_POINT}api/users`, {
      params: {
        filters: {
          prospect: { id: { $eq: id } },
        },
      },
    });
    console.log(data);
    dispatch({ type: "PROSPECT_USERS_SUCCESS", payload: data });
  } catch (error) {
    console.log(error);
    dispatch({ type: "PROSPECT_USERS_ERROR", payload: error });
  }
};

export const getProspectUser = (id) => async (dispatch) => {
  dispatch({ type: "PROSPECT_USER_LOADING" });
  try {
    const { data } = await API.get(`${API_END_POINT}api/users/${id}`);
    dispatch({ type: "PROSPECT_USER_SUCCESS", payload: data });
  } catch (error) {
    console.log(error);
    dispatch({ type: "PROSPECT_USER_ERROR", payload: error });
  }
};

export const createProspectUser =
  (prospectId, userData, t, callback) => async (dispatch) => {
    dispatch({ type: "CREATE_PROSPECT_USER_LOADING" });
    try {
      const { data } = await API.post(`${API_END_POINT}api/users`, {
        ...userData,
        username: `${userData.firstName}-${userData.lastName}-${getRandomNumber(
          1000,
          9999,
        )}`,
        userRole: 5,
        role: 0,
        prospect: prospectId,
      });
      dispatch({ type: "CREATE_PROSPECT_USER_SUCCESS", payload: data });
      toast.success(t("Profile created successfully!"));
      if (callback) callback();
    } catch (error) {
      console.log(error);
      dispatch({ type: "CREATE_PROSPECT_USER_ERROR", payload: error });
    }
  };

export const updateProspectUser =
  (id, userData, t, callback) => async (dispatch) => {
    dispatch({ type: "UPDATE_PROSPECT_USER_LOADING" });
    try {
      const { data } = await API.put(`${API_END_POINT}api/users/${id}`, {
        ...userData,
      });
      dispatch({ type: "UPDATE_PROSPECT_USER_SUCCESS", payload: data });
      toast.success(t("Profile updated successfully!"));
      if (callback) callback();
    } catch (error) {
      console.log(error);
      dispatch({ type: "UPDATE_PROSPECT_USER_ERROR", payload: error });
    }
  };

export const deleteProspectUser = (id, t) => async (dispatch) => {
  dispatch({ type: "DELETE_PROSPECT_USER_LOADING" });
  try {
    await API.delete(`${API_END_POINT}api/users/${id}`);
    dispatch({ type: "DELETE_PROSPECT_USER_SUCCESS", payload: id });
    toast.success(t("Profile deleted successfully!"));
  } catch (error) {
    console.log(error);
    dispatch({ type: "UPDATE_PROSPECT_USER_ERROR", payload: error });
  }
};
